import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ICampaignData, ICampaignSliderPopup, IPopupModelV2, ModalChild } from '@mwe/models';
import { WINDOW_TOKEN } from '@mwe/constants';
import { ButtonComponent } from '../buttons/button/button.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mwe-campaign-popup',
  templateUrl: './campaign-popup.component.html',
  imports: [ButtonComponent, ModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPopupComponent implements ModalChild {
  popupModel = signal<IPopupModelV2>(null);
  // data set from PopupService
  loadedData: ICampaignData;

  private activeModal = inject(NgbActiveModal);
  private router = inject(Router);
  private window = inject(WINDOW_TOKEN);

  popupData = computed<ICampaignSliderPopup>(() => this.loadedData?.slider?.popup);

  closePopup(): void {
    this.activeModal.close('OK');
  }

  startNewClientProcess(): void {
    this.closePopup();
    this.navigate(this.popupData()?.newClientUri);
  }

  startTariffChangeProcess(): void {
    this.closePopup();
    this.navigate(this.popupData()?.tariffChangeUri);
  }

  private navigate(url: string): void {
    if (url.includes('http')) {
      this.window.open(url, '_blank');
      return;
    }

    this.router.navigateByUrl(url);
  }
}
